import AddressStartApi from './AddressStartApi';

const emptyAddressObject = {
  legacyId: '',
};

function addressesFromStart() {
  const {start} = window;
  const startAddresses = (start && start.addresses && start.addresses.addresses);
  if (!startAddresses || !Array.isArray(startAddresses) || startAddresses.length === 0) {
    return [emptyAddressObject];
  }
  return startAddresses;
}

const startGetDeliveryAddressListData = () => addressesFromStart().map(address => new AddressStartApi(address));

const getSelectedIndex = () => window.start?.addresses?.selectedIndex || 0;

function getSelectedAddressId() {
  if (window.start?.addresses?.selectedAddressId) {
    return window.start?.addresses?.selectedAddressId;
  }
  let defaultDeliveryAddressId = 0;
  addressesFromStart().forEach((startAddress) => {
    if (startAddress.defaultDeliveryAddress) {
      defaultDeliveryAddressId = startAddress.legacyId;
    }
  });
  return defaultDeliveryAddressId;
}

const getSelectedAddressCategory = () => window.start?.addresses?.selectedAddressCategory;

const startGetSelectedDeliveryAddressId = () => {
  const selectedAddressId = getSelectedAddressId();
  const addressList = addressesFromStart();
  if (selectedAddressId || selectedAddressId === '') {
    return selectedAddressId;
  }
  const selectedIndex = getSelectedIndex();
  const selectedAddress = addressList[selectedIndex];
  return (selectedAddress && selectedAddress.legacyId) || '';
};

const startGetSelectedDeliveryAddressCategory = (addressId) => {
  const selectedAddressCategory = getSelectedAddressCategory();

  if (selectedAddressCategory) {
    return selectedAddressCategory;
  }
  
  return addressId !== '' ? 'STORED_RESIDENTIAL_ADDRESS' : 'NEW_RESIDENTIAL_ADDRESS';
};

export const isReadingAddressesFromStart = () => {
  const {start} = window;
  if (start && start.addresses && start.addresses.addresses) {
    return Array.isArray(start.addresses.addresses);
  }
  return false;
};

export const getSelectedDeliveryAddressId = () => {
  if (isReadingAddressesFromStart()) {
    return startGetSelectedDeliveryAddressId();
  }
  return '';
};

export const getSelectedDeliveryAddressCategory = (addressId) => {
  if (isReadingAddressesFromStart()) {
    return startGetSelectedDeliveryAddressCategory(addressId);
  }
  return 'UNKNOWN';
};

export const getDeliveryAddressListData = () => {
  if (isReadingAddressesFromStart()) {
    return startGetDeliveryAddressListData();
  }
  return [emptyAddressObject];
};
